import { render, staticRenderFns } from "./CataloguePorque.vue?vue&type=template&id=33022774"
import script from "./CataloguePorque.vue?vue&type=script&lang=js"
export * from "./CataloguePorque.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports